import { IFormItemProps } from '@/components';
/**
 * 设置PromptText到配置中
 * @param config
 * @param values
 * @param params
 * @returns
 */
export const orgConfigToPromptText = (config: IFormItemProps, values: any, params: {
  disabled?: boolean,
  promptTextKey?: string
}) => {
  const { disabled, promptTextKey } = params || {};
  return {
    ...config,
    uiOptions: {
      ...config?.uiOptions,
      promptText: promptTextKey ? values?.[promptTextKey] || '' : '',
      disabled: disabled === undefined ? config?.uiOptions?.disabled : disabled || config?.uiOptions?.disabled,
    },
  };
};

/**
 * 结构化配置-用于表单配置
 * @param config
 * @param values
 * @param params
 * @returns
 */
export const orgConfigs = (config: IFormItemProps[], values: any, params: {
  disabled?: boolean,
  promptTextKey?: string
}) => {
  const { disabled } = params || {};
  return config?.map((e) => {
    if (e?.render === 'pic' || e?.render === 'audio') {
      return orgConfigToPromptText(e, values, params);
    }
    return {
      ...e,
      uiOptions: {
        ...e?.uiOptions,
        disabled: disabled === undefined ? e?.uiOptions?.disabled : disabled || e?.uiOptions?.disabled,
      },
    };
  });
};
